const internals = {};

exports.networkErrs = [
    'ERR_NETWORK',
    // Axios-specific errors
    'ERR_TIMEOUT',
    'ECONNABORTED',

    // Browser-specific errors (Chromium-based browsers)
    'ERR_INTERNET_DISCONNECTED',
    'ERR_CONNECTION_RESET',
    'ERR_CONNECTION_REFUSED',
    'ERR_NAME_NOT_RESOLVED',
    'ERR_ADDRESS_UNREACHABLE',
    'ERR_NETWORK_CHANGED',
    'ERR_TIMED_OUT',
    'ERR_TUNNEL_CONNECTION_FAILED',
    'ERR_EMPTY_RESPONSE',
    'ERR_FAILED',
    'ERR_ABORTED',
    'ERR_TOO_MANY_REDIRECTS',

    // SSL/TLS-related errors
    'ERR_CERT_AUTHORITY_INVALID',
    'ERR_SSL_PROTOCOL_ERROR',
    'ERR_SSL_CERT_COMMON_NAME_INVALID',
    'ERR_CERT_DATE_INVALID',
    'ERR_CERT_INVALID',
    'ERR_BAD_SSL_CLIENT_AUTH_CERT',
    'ERR_INSECURE_RESPONSE',

    // Proxy-related errors
    'ERR_PROXY_CONNECTION_FAILED',

    // General network errors
    'ENETUNREACH', // Network is unreachable
    'EHOSTUNREACH', // Host is unreachable
    'ECONNREFUSED', // Connection refused by the server
    'ETIMEDOUT', // Connection attempt timed out
    'ECONNRESET',
    'EAI_AGAIN',
    'ERR_NETWORK_IO_SUSPENDED',
    'ERR_NETWORK_ACCESS_DENIED',
    'ERR_NETWORK_DISCONNECTED',

    // Client-side errors
    'ERR_BLOCKED_BY_CLIENT',
    'ERR_BLOCKED_BY_RESPONSE'
];

exports.transientNetworkErrs = [
    'ERR_NETWORK',
    'ERR_TIMEOUT',
    'ECONNABORTED',
    'ERR_INTERNET_DISCONNECTED',
    'ERR_CONNECTION_RESET',
    'ERR_CONNECTION_REFUSED',
    'ERR_NAME_NOT_RESOLVED',
    'ERR_ADDRESS_UNREACHABLE',
    'ERR_NETWORK_CHANGED',
    'ERR_TIMED_OUT',
    'ERR_TUNNEL_CONNECTION_FAILED',
    'ERR_EMPTY_RESPONSE',
    'ERR_FAILED',
    'ERR_ABORTED',
    'ERR_PROXY_CONNECTION_FAILED',
    'ENETUNREACH',
    'EHOSTUNREACH',
    'ECONNREFUSED',
    'ETIMEDOUT',
    'ECONNRESET',
    'EAI_AGAIN',
    'ERR_NETWORK_IO_SUSPENDED',
    'ERR_NETWORK_ACCESS_DENIED',
    'ERR_NETWORK_DISCONNECTED'
];

exports.isCanceledRequest = (error) => {

    const code = error?.code;
    const message = String(error?.message || '').toLowerCase();

    return error?.__CANCEL__ === true
        || error?.name === 'CanceledError'
        || code === 'ERR_CANCELED'
        || message === 'canceled'
        || message === 'cancelled';
};

exports.isDeviceOffline = () => {

    if (typeof navigator === 'undefined') {
        return false;
    }

    const connectionType = navigator.connection?.type;
    const cordovaOfflineType = globalThis.Connection?.NONE || 'none';

    return navigator.onLine === false
        || (connectionType && connectionType === cordovaOfflineType);
};

exports.isOfflineError = (error) => {

    if (exports.isCanceledRequest(error)) {
        return false;
    }

    return exports.isDeviceOffline() || exports.isTransientNetworkError(error);
};

exports.isTransientNetworkError = (error) => {

    if (exports.isCanceledRequest(error)) {
        return false;
    }

    const code = error?.code;
    const message = String(error?.message || '').toLowerCase();

    if (exports.transientNetworkErrs.includes(code)) {
        return true;
    }

    return message.includes('network error')
        || message.includes('failed to fetch')
        || message.includes('load failed');
};

exports.isRecoverableServerError = (error) => internals.RECOVERABLE_SERVER_STATUSES.has(error?.response?.status);

internals.RECOVERABLE_SERVER_STATUSES = new Set([500, 502, 503, 504]);
